<script setup lang="ts">
import type { Schemas } from "#shopware";
import { formatPrice } from "~/helpers/formatters";

const props = defineProps<{
	product: Schemas["Product"];
}>();

const { product } = toRefs(props);

const { tierPrices } = useProductPrice(product);

const tierPricingText = computed(() => {
	if (tierPrices.value.length > 1) {
		return `vanaf ${tierPrices.value[1].quantity} stuks ${formatPrice(tierPrices.value[1].unitPrice)} per stuk`;
	}

	return "";
});
</script>
<template>
	<div class="flex flex-col">
		<span class="text-xl font-bold">
			{{ formatPrice(product.calculatedPrice?.totalPrice) }}
		</span>
		<span v-if="tierPrices.length > 1" class="text-xs font-normal">
			{{ tierPricingText }}
		</span>
	</div>
</template>
